module.exports = "pegasus/assets/blocks/column-2-theme4.png";